module.exports = __webpack_public_path__ + "static/img/business.b7eed2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/business.png
// module id = 50nh
// module chunks = 0